module.exports = __webpack_public_path__ + "img/2.bcd30094.jpg";